import React, { ReactNode, Fragment } from 'react';
import { Container } from '../shared/Container';

interface BaseLayoutProps {
    children?: ReactNode;
}

export function BaseLayout({ children }: BaseLayoutProps) {
    return (
        <Fragment>
            <main id="content" role="main" className="refinance-calculator">
                <Container>{children}</Container>
            </main>
        </Fragment>
    );
}
